export const PaymentMethod = [
  { value: "", label: "Select Payment Method" },
  { value: "LovesNationalAccount", label: "Love's National Account" },
  { value: "TaNationalAccount", label: "TA National Account" },
  { value: "MichelinNationalAccount", label: "Michelin National Account" },
  {
    value: "BridgestoneNationalAccount",
    label: "Bridgestone National Account",
  },
  {
    value: "ContinentalNationalAccount",
    label: "Continental National Account",
  },
  {
    value: "PompsNationalAccount",
    label: "Pomp's National Account",
  },
  {
    value: "SouthernTireMartNationalAccount",
    label: "Southern Tire Mart National Account",
  },
  { value: "CreditCard", label: "Credit Card" },
  { value: "Cash", label: "Cash" },
  { value: "EFS", label: "EFS" },
  { value: "Warranty", label: "Warranty" },
  { value: "PaidByDriver", label: "Paid By Driver" },
  { value: "DealerAccount", label: "Dealer Account" },
  { value: "Other", label: "Other" },
];
